import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpService } from '../../../services/http.service';
import { CustomToastComponent } from '../../toast/custom-toast.component';
import { InputComponent } from '../../from-input/input.component';

@Component({
  selector: 'app-event-copy-link',
  standalone: true,
  templateUrl: './add-feedback-dialog.component.html',
  styleUrls: ['./add-feedback-dialog.component.scss'],
  imports: [CommonModule, ReactiveFormsModule, InputComponent],
})
export class AddFeedBackDialogComponent implements OnInit {
  form!: FormGroup;
  loading = false;
  customErrorMessages = {
    decline: { required: 'Please enter a reason for declining.' },
    ccEmail: { required: 'Please enter your feedback.' },
  };
  actionType: any = '';

  constructor(
    private fb: FormBuilder,
    private httpService: HttpService,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<AddFeedBackDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { eventData: any; action?: string; eventId: string },
  ) {
    this.actionType = data.action;
  }

  ngOnInit(): void {
    if (this.actionType) {
      // For decline action
      this.form = this.fb.group({
        decline: [''],
      });
    } else {
      this.form = this.fb.group({
        ccEmail: ['', Validators.required],
      });
    }
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onSend(): void {
    if (this.form.invalid) {
      // Mark all fields as touched to show validation errors
      Object.keys(this.form.controls).forEach((key) => {
        this.form.get(key)?.markAsTouched();
      });
      return;
    }

    this.loading = true;
    const feedback = this.form.get('ccEmail')?.value;

    // Add your API call logic here for sending feedback
    // Example:
    // this.httpService.post('your-endpoint', { feedback })
    //   .pipe(finalize(() => this.loading = false))
    //   .subscribe({
    //     next: (response) => {
    //       this.showSuccessToast('Feedback sent successfully');
    //       this.dialogRef.close(true);
    //     },
    //     error: (error) => {
    //       this.showErrorToast(error.message);
    //       this.loading = false;
    //     }
    //   });

    // For demo purposes:
    setTimeout(() => {
      this.showSuccessToast('Feedback sent successfully');
      this.dialogRef.close(true);
      this.loading = false;
    }, 1000);
  }

  declineEvent(): void {
    if (this.form.invalid) {
      // Mark decline field as touched to show validation error
      this.form.get('decline')?.markAsTouched();
      return;
    }

    this.loading = true;
    const declineReason = this.form.get('decline')?.value;
    const status = false; // false indicates declined

    this.httpService
      .put<any>(
        `events/student-events/${this.data.eventId}/teacher-approval?status=${status}&comment=${encodeURIComponent(declineReason)}`,
        {},
      )
      .subscribe({
        next: (response) => {
          this.loading = false;
          if (response.status) {
            this.showSuccessToast(response.message);
            this.dialogRef.close(true);
          } else {
            this.showErrorToast(response.message);
          }
        },
        error: (err) => {
          console.error('Failed to decline event:', err);
          this.showErrorToast(err?.message || 'Failed to decline event');
          this.loading = false;
        },
      });
  }

  private showSuccessToast(message: string): void {
    this.snackBar.openFromComponent(CustomToastComponent, {
      data: { message, type: 'success' },
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: ['success-toast'],
    });
  }

  private showErrorToast(message: string): void {
    this.snackBar.openFromComponent(CustomToastComponent, {
      data: { message, type: 'error' },
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: ['error-toast'],
    });
  }
}
